import React from 'react'
import { Button, Col, Divider, Form, Input, InputNumber, Row, Select } from 'antd'
import { FormComponent } from '../../../BaseComponent'
import QuestionRange from './QuestionRange'
import QuestionAnswers from './QuestionAnswers'
import IQuestionGroup from '../../../../interfaces/IQuestionGroup'

type QuestionTabProps = {
  values?: any,
  loading: boolean,

  groups: IQuestionGroup[],

  onSave: (values: any) => void
}

export default class QuestionMain extends FormComponent<QuestionTabProps> {

  state = {
    formTag: ''
  }

  componentDidMount() {
    const { values } = this.props

    if (values?.form_tag_key) {
      this.setState({
        formTag: values?.form_tag_key
      })
    }
  }

  handleFormTagChange = (value: any) => {
    this.setState({
      formTag: value
    })
  }

  render() {
    const { values, groups, loading, onSave } = this.props
    const { formTag } = this.state

    const groupsOptions = groups?.map(group => {
      return {
        label: group.name,
        value: group.id
      }
    })

    const tagsOptions = [
      {
        label: 'CHECKBOX',
        value: 'CHECKBOX'
      },
      {
        label: 'RADIO',
        value: 'RADIO'
      },
      {
        label: 'RANGE',
        value: 'RANGE'
      },
      {
        label: 'SELECT',
        value: 'SELECT'
      },
      {
        label: 'TEXT',
        value: 'TEXT'
      },
    ]

    return (
      <Form
        name="question_main"
        initialValues={values}
        layout="vertical"
        onFinish={onSave}
        ref={(refs: any) => {
          if (!this.formRef) {
            this.formRef = refs
            this.forceUpdate()
          }
        }}
      >
        <Row gutter={24}>
          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Group"
              name="group_id"
              rules={[
                {
                  required: true,
                  message: 'Please select a group'
                }
              ]}
            >
              <Select
                placeholder="Select a group"
                options={groupsOptions}
              />
            </Form.Item>
            
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  label="Question Type"
                  name="form_tag_key"
                  rules={[
                    {
                      required: true,
                      message: 'Please select a question type'
                    }
                  ]}
                >
                  <Select
                    placeholder="Select question type"
                    options={tagsOptions}
                    onChange={this.handleFormTagChange}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  label="Position"
                  name="position"
                  rules={[
                    {
                      required: true,
                      message: 'Missing a position'
                    }
                  ]}
                >
                  <InputNumber placeholder="Position" min={0} max={100} />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} sm={12} md={12}>
            <Form.Item
              label="Question"
              name="ask"
              rules={[
                {
                  required: true,
                  message: 'Missing an question'
                }
              ]}
            >
              <Input.TextArea placeholder="Ask your question here" rows={4} />
            </Form.Item>
            
            <Divider />

            {
              // Render answers multiple fields
              formTag === 'SELECT' || formTag === 'RADIO' || formTag === 'CHECKBOX' ? (
                this.formRef ? <QuestionAnswers formRef={this.formRef} /> : null
              ) : (
                formTag === 'RANGE' ? <QuestionRange start={values?.rule?.start} end={values?.rule?.end} step={values?.rule?.step} /> : null
              )
            }
          </Col>
        </Row>

        <Divider />

        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" loading={loading} size="large" ref={(refs) => this.actionRefs.save = refs} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}
